import {initialState, NAME_SLICE} from "./constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IChecklist} from "../../varibles/interface";

const checklistSlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        gets: (state) => {
            state.loading = true;
        },
        getsSuccess: (state, action: PayloadAction<IChecklist[]>) => {
            state.loading = false;
            state.data = action.payload;
        },
        getsFailure: (state) => {
            state.loading = false;
        },
        getSteps: (state) => {
            state.steps.loading = true;
        },
        getStepsSuccess: (state, action: PayloadAction<{[id: string]: string[]}>) => {
            state.steps.loading = false;
            state.steps.data = action.payload;
        },
        getStepsFailure: (state) => {
            state.steps.loading = false;
        },
        add: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = [...data, factory];
        },
        update: (state, action) => {
            const factory = action.payload;
            const {data} = state;
            state.data = data.map(item => item.id === factory.id ? factory : item)
        },
        delete: (state, action) => {
            const id = action.payload;
            const {data} = state;
            state.data = data.filter(item => item.id !== id);
        },
    },
})

export const checklistActions = checklistSlice.actions

const checklistReducer = checklistSlice.reducer;

export default checklistReducer;
